/*
 * @Author: alex
 * @Date: 2022-11-14 09:29:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-23 17:26:06
 * @Description: map context
 * Copyright (c) 2022 by piesat, All Rights Reserved.
 */
import { TypeEvented } from '@vmap/core'
import type * as ol from 'ol'
import { MapContainer } from './mapContainer'
import { MapStyle } from './mapSpecification'

export interface MapEvent {
  evt_layer_visible: { lyrId: string; visible: boolean }
  map_ready: { map: ol.Map }
  // 隐藏地图元素;
  map_hidden: any
  // 显示地图元素
  map_shown: any
  // 暂停地图控件
  map_control_pause: { id: string }
  // 地图图层添加事件
  map_layer_added: { lyrId: string }
  [key: string]: unknown
}

class MapContext extends TypeEvented<MapEvent> {
  #map!: ol.Map

  #mc!: MapContainer

  #style!: MapStyle

  static INSTANCE = new MapContext()

  private constructor() {
    super()
  }

  setMainMap(map: ol.Map) {
    this.#map = map
  }

  getMainMap() {
    return this.#map
  }

  getMapContainer() {
    return this.#mc
  }

  setMapContainer(mc: MapContainer) {
    this.#mc = mc
  }

  setMapStyle(mapStyle: MapStyle) {
    this.#style = mapStyle
  }

  getMapStyle() {
    return this.#style
  }
}

export const mapContext = MapContext.INSTANCE
